import { render, staticRenderFns } from "./CovidScreeningStatus.vue?vue&type=template&id=2fa26142&"
import script from "./CovidScreeningStatus.vue?vue&type=script&lang=js&"
export * from "./CovidScreeningStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports